import { render, staticRenderFns } from "./CfgFornecedor.vue?vue&type=template&id=078a08f3"
import script from "./CfgFornecedor.vue?vue&type=script&lang=js"
export * from "./CfgFornecedor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports